import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { propertyCardSaveAreaStyles } from './styles/property-card-save-area.styles';
import type { PropertyCardSaveAreaPropsInterface } from './types/property-card-save-area.types';

/**
 * A container for the save button in a `PropertyCard`.
 *
 * @since 8.67.0
 */
export const PropertyCardSaveArea = forwardRef<HTMLDivElement, PropertyCardSaveAreaPropsInterface>(
  (props: PropertyCardSaveAreaPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const styles = css(propertyCardSaveAreaStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="PropertyCard.SaveArea"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

PropertyCardSaveArea.displayName = 'PropertyCard.SaveArea';
